'use client';

import { type ComponentPropsWithRef, type ReactNode } from 'react';

import {
  Button,
  type ButtonMode,
  type DefaultIconSize,
  type IconShapeVariant,
} from '@repo/ui/Button';
import { Icon } from '@repo/ui/Icon';
import { type IconNames } from '@repo/ui/Icon/utils';
import { VisuallyHidden } from '@repo/ui/VisuallyHidden';

export interface IconButtonProps extends ComponentPropsWithRef<'button'> {
  ariaDisabled?: boolean;
  className?: string;
  disabled?: boolean;
  icon: IconNames;
  isLoading?: boolean;
  label: string | ReactNode;
  loadingLabel?: string;
  mode?: ButtonMode;
  size?: DefaultIconSize;
  variant?: IconShapeVariant;
}

export const IconButton = (props: IconButtonProps) => {
  const {
    disabled = false,
    icon,
    isLoading = false,
    label,
    size = 'md',
    variant = 'primary',
    ...attrs
  } = props;

  return (
    <Button
      disabled={disabled}
      isLoading={isLoading}
      shape="icon"
      size={size}
      variant={variant}
      {...attrs}
    >
      <Icon name={icon} size={size} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </Button>
  );
};
